import { CreateActionParams } from '../../actions';

export async function handleTemplateFlow({
  context: { wixSdkAdapter },
}: CreateActionParams) {
  await wixSdkAdapter.openEcomCheckoutTemplateModal();
}
